import { render, staticRenderFns } from "./_NotifSubmissionNew.vue?vue&type=template&id=8237a522&scoped=true&"
import script from "./_NotifSubmissionNew.vue?vue&type=script&lang=js&"
export * from "./_NotifSubmissionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8237a522",
  null
  
)

export default component.exports